exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-tag {\n    margin: 0 10px 10px 0;\n}\n", ""]);

// exports
